import Model from './Model.vue'

export default Model
